import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import { Box } from './StyledComponents';
import DeliverForm from './DeliverForm.jsx';
import TilePreview from './TilePreview.jsx';
import { useDeliverForm } from './useDeliverForm.jsx';
import { DeliverFormProvider } from './DeliverFormProvider.jsx';

const Wrapper = styled.div`
  display: flex;
  font-family: 'Montserrat';
  margin: 24px 0 0;

  @media only screen and (max-width: 1390px) {
    flex-direction: column;
  }
`;

const LeftSection = styled.div`
  width: 100%;
  margin: 0 40px 0 0;
  max-width: 440px;

  @media only screen and (max-width: 1250px) {
    max-width: 100%;
    margin-bottom: 30px;
  }
`;

const RightSection = styled.div`
  width: 100%;
`;

const ActivityWrapper = styled(Box)`
  background-color: ${themeGet('colors.white')};
  padding: 8px 24px;
  margin: 0 0 16px;
`;

const ActivityTile = styled.h2`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${themeGet('colors.black.80')};
`;

const DeliveredTiles = styled.p`
  margin: 1px 0 0;
  font-size: 12px;
  font-weight: 400;
  color: ${themeGet('colors.black.80')};
  line-height: 22px;
`;

const Deliver = () => {
  const { t } = useTranslation('send');
  const { deliver } = useDeliverForm();

  return (
    <Wrapper>
      <LeftSection>
        <ActivityWrapper>
          <ActivityTile>{t('deliver.activityTile')}</ActivityTile>
          <DeliveredTiles>{deliver.activity}</DeliveredTiles>
        </ActivityWrapper>
        <DeliverForm />
      </LeftSection>
      <RightSection>
        <TilePreview />
      </RightSection>
    </Wrapper>
  );
};

export default function DeliverWithProvider({
  emailPreviewPath,
  smsPreviewPath,
}) {
  return (
    <DeliverFormProvider
      emailPreviewPath={emailPreviewPath}
      smsPreviewPath={smsPreviewPath}
    >
      <Deliver />
    </DeliverFormProvider>
  );
}
